import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            style={{ width: "75%" }}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function CustomerDetail({ ...props }) {
    const [value, setValue] = React.useState(0);
    const [t] = useTranslation("global");

    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', width: '75%' }} >
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label={t("customers.tabs.locations")} {...a11yProps(0)} disabled={props.locationDisabled}/>
                    <Tab label={t("customers.tabs.taxes")} {...a11yProps(1)} disabled={props.taxesDisabled}/>
                    <Tab label={t("customers.tabs.items")} {...a11yProps(2)} disabled={props.itemsDisabled}/>
                    <Tab label={t("customers.tabs.bankaccounts")} {...a11yProps(3)} disabled={props.banksDisabled}/>
                    <Tab label={t("customers.tabs.files")} {...a11yProps(4)} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
                {props.Locations}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
                {props.Taxes}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
                {props.Items}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
                {props.CustomerBankAccounts}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={4}>
                {props.Files}
            </CustomTabPanel>
        </Box>
    );
}